import WorkoutForm from './WorkoutForm'
export default WorkoutForm



// WEBPACK FOOTER //
// ./src/components/workouts/WorkoutForm/index.js